module.exports = __webpack_public_path__ + "ceb3b8aa3c9b774411822bcb34bbd990.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/bg-img-03.png
// module id = 721
// module chunks = 0